import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  AfterViewInit,
  ViewChild,
} from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { FormErrors } from '../../../shared/api/response.error';
import { SavedUsernameService } from '../../../shared/saved-username.service';
import { SpenModule } from '@classi/spen';

@Component({
  imports: [ReactiveFormsModule, SpenModule],
  selector: 'app-login-identifier-form',
  templateUrl: './login-identifier-form.component.html',
  styleUrls: ['./login-identifier-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginIdentifierFormComponent implements AfterViewInit {
  @Input()
  formErrors!: FormErrors | null;
  @Input()
  submitInProgress!: boolean;

  @Output()
  login = new EventEmitter<{ username: string; password: string }>();

  @ViewChild('idInput', { read: ElementRef, static: false })
  idInput: ElementRef<HTMLElement> | null = null;

  readonly form = this.fb.group({
    username: this.fb.control(this.savedUsernameService.getId(), {
      // TODO: 文字種のバリデーションがあれば追加(記号、全角、長さ)
      validators: [Validators.required],
    }),
    password: this.fb.control('', {}),
  });

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly savedUsernameService: SavedUsernameService
  ) {}

  ngAfterViewInit(): void {
    // ページを開いた時にID入力欄にフォーカス
    if (this.idInput) {
      this.idInput.nativeElement.focus();
    }
  }

  onSubmit() {
    this.login.emit(this.form.value);
  }
}
